module.exports = __webpack_public_path__ + "img/zero_new.72dd4502.png";